import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) =>
  state.couplingsAndBrackets || initialState;

export const selectCouplingsAndBrackets = createSelector(
  [selectSlice],
  state => state.data,
);

export const selectCoupling = createSelector(
  [selectSlice],
  state => state.data?.coupling || null,
);

export const selectBracket = createSelector(
  [selectSlice],
  state => state.data?.bracket || null,
);
